import React from 'react';

class Input extends React.Component {
  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <div className={this.props.className}>
        <label className="ip-label">{this.props.title}</label>
        <input type="text" name={this.props.name} placeholder={this.props.placehoderText} className="search-input" onChange={this.onChange.bind(this)} />
      </div>
    );
  }
}

Input.defaultProps = {
  title: 'Từ khóa',
  className: 'input-group-show',
  name: 'searchKey',
  placehoderText: 'Nhập tên người đứng đơn hoặc số CMND để tìm kiếm...',
  onChange: function () {
    console.log('Please assign onChange function');
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/list-handle-letters-search/Input.jsx